export default __webpack_public_path__ + "static/media/logo_transparent-sq.de29b277.png";